<template>
  <div class="overview-section">
    <TopBar>
      <template v-slot:left>
      </template>
      <template v-slot:right>
        <MonthSelector />
      </template>
    </TopBar>

    <div class="overview-grid">

      <div class="stat-card" v-for="(card, index) in statsCards" :key="`stats-card-${index}`">
        <div class="card-accent"></div>
        <div class="stat-icon-wrapper" :class="card.type">
          <div class="stat-icon">
            <i :class="card.icon"></i>
          </div>
        </div>
        <div class="stat-content">
          <div class="stat-title">{{ card.title }}</div>
          <div class="stat-value mb20">{{ card.value }}</div>
          <div class="stat-details-row" v-if="card.extra && card.extra.length" v-for="(item, itemIndex) in card.extra"
            :key="`stats-card-${index}-extra-${itemIndex}`">
            <span class="detail-label">
              {{ item.name }}
            </span>
            <span class="detail-value">
              {{ item.value || item.amount || 0 }}
            </span>
          </div>
        </div>
      </div>
    </div>

    <div class="chart-section">
      <RollingEarningsGraph :loading="isWaiting" />
    </div>


  </div>
</template>

<script>

import MonthSelector from '@/components/shared/MonthSelector.vue'
import RollingEarningsGraph from './RollingEarningsGraph'
import { mapGetters, mapState } from 'vuex'
import Api from '../services/ApiGateway'
import TopBar from '../components/shared/TopBar.vue'


export default {
  components: {
    TopBar,
    MonthSelector,
    RollingEarningsGraph,
  },
  data() {
    return {
      isWaiting: true,
    }
  },
  watch: {
    // Executes instantly once component comes into view, and each time the date changes
    getActiveDates(previous, current) {
      this.getOverviewStats();
    }
  },
  computed: {
    ...mapState({
      currentMonthRevenues: state => state.statisticsModule.currentMonthRevenues,
      revenuesBreakdown: state => state.statisticsModule.revenuesBreakdown,
      averageBookingsAmount: state => state.statisticsModule.averageBookingsAmount,
      tripsBookedCount: state => state.statisticsModule.tripsBookedCount,
      transactionsCount: state => state.statisticsModule.transactionsCount,
      affiliationAmounts: state => state.statisticsModule.affiliationAmounts,
      bookingsPerCode: state => state.statisticsModule.bookingsPerCode,
      tripsPerCode: state => state.statisticsModule.tripsPerCode,
      tripsTraveledCount: state => state.statisticsModule.tripsTraveledCount,
      transactionsBreakdown: state => state.statisticsModule.transactionsBreakdown,
      model: state => state.statisticsModule.model,
      projectedMonthlyEarnings: state => state.statisticsModule.projectedMonthlyEarnings,
    }),
    ...mapGetters({
      getActiveDates: 'datesModule/getActiveDates',
      impersonateUser: 'authentication/impersonateUser',
      projectedEarningsTotal: 'statisticsModule/projectedEarningsTotal',
    }),
    statsCards() {
      const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec']
      const euroFormat = Intl.NumberFormat('en-DE', { style: 'currency', currency: 'EUR' })
      const projectedEarningsBreakdown = this.projectedMonthlyEarnings.map(entry => ({
        name: `${monthNames[entry.month - 1]} ${entry.year}`,
        value: euroFormat.format(entry.amount),
      }))

      return [
        {
          visible: true,
          type: 'success',
          icon: 'fa fa-euro',
          title: 'Affiliation Revenues',
          value: this.currentMonthRevenues,
          extra: this.revenuesBreakdown,
        },
        {
          visible: true,
          type: 'warning',
          icon: 'fa fa-shopping-cart',
          title: 'Bookings Performed',
          value: this.transactionsCount,
          extra: this.bookingsPerCode,
        },
        {
          visible: this.model === 'TRAVEL_DATE_ATTRIBUTION',
          type: 'danger',
          icon: 'fa fa-bar-chart',
          title: 'Trips Traveled',
          value: this.tripsTraveledCount,
          extra: this.tripsPerCode,
        },
        {
          visible: this.model === 'TRAVEL_DATE_ATTRIBUTION' && this.projectedMonthlyEarnings.length > 0,
          type: 'success',
          icon: 'fa fa-line-chart',
          title: 'Pending Earnings',
          value: this.projectedEarningsTotal,
          extra: projectedEarningsBreakdown,
        },
        {
          visible: this.model === 'BOOKING_DATE_ATTRIBUTION',
          type: 'warning',
          icon: 'fa fa-euro',
          title: 'Average order value',
          value: this.averageBookingsAmount,
          extra: this.affiliationAmounts,
        },
        {
          visible: this.model === 'BOOKING_DATE_ATTRIBUTION',
          type: 'danger',
          icon: 'fa fa-bar-chart',
          title: 'Trips Booked',
          value: this.tripsBookedCount
        }
      ].filter(c => c.visible);
    }
  },
  methods: {
    getOverviewStats() {
      this.isWaiting = true;
      Api.getUserData(this.impersonateUser).then(({ data }) => {
        this.$store.dispatch('statisticsModule/setStatistics', data)
        this.isWaiting = false;
      }).catch(console.log)
    },
  }
}
</script>


<style scoped>
.overview-section {
  padding: 1rem 0;
}

.overview-toolbar {
  margin-bottom: 2rem;
}

.overview-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 1.5rem;
}


.chart-section {
  margin-top: 2rem;
}
</style>
